import { HttpInterceptorFn } from '@angular/common/http';

export const devInterceptor: HttpInterceptorFn = (req, next) => {
  // if (req.method === 'GET' && req.url.includes('report-onss/')) {
  //   return next(req.clone({ url: 'assets/dev_mock/report-onss.json' }));
  // }
  // if (req.method === 'GET' && req.url.includes('rpj?')) {
  //   return next(req.clone({ url: 'assets/dev_mock/rpj.json' }));
  // }
  // if (req.method === 'OPTIONS' && req.url.includes('rpj')) {
  //   return next(req.clone({ url: 'assets/dev_mock/rpj.schema.json' }));
  // }
  // if (req.method === 'GET' && req.url.includes('hist')) {
  //   return next(req.clone({ url: 'assets/dev_mock/hist.json' }));
  // }
  return next(req);
};
